const translations = {
    formSelection: 'Form Selection',
    newFormLinkText: 'New {{resource}} Form'
};

export default translations;
